export default __webpack_public_path__ + "static/allergy-amulet-featured-banner-63ed8e478b4d246e7b3ae589272b13c0.webp";